<template>
  <div class="lens-input-component">
      <el-input-number
        v-model="yValue" size="small"
        :precision="2"
        :step="0.25"
        :controls="false"
        :min="-20"
        :max="20"
        placeholder="球镜"
        @change="handleYChange"
        @focus="handleFocus('y')"
        style="width: 66px; margin-right: 2px;"
      />
      <el-input-number
        v-model="xValue"
        :precision="2"
        :step="0.25" size="small"
        :controls="false"
        :min="-10"
        :max="10"
        placeholder="柱镜"
        @blur="handleXBlur"
        @focus="handleFocus('x')"
        style="width: 66px;"
      />
  </div>
</template>

<script>
  export default {
    name: 'LensInput',

    props: {
    },

    data() {
      return {
        yValue: undefined,  // 球镜
        xValue: undefined,  // 柱镜
        yValueFilled: false
      }
    },
    methods: {
      // 处理输入框获得焦点事件
      handleFocus(type) {
        this.$nextTick(() => {
          this.selectInputText(type)
        })
      },

      // 全选输入框文本
      selectInputText(type) {
        let inputRef
        if (type === 'y') {
          inputRef = this.$refs.yInputRef
        } else if (type === 'x') {
          inputRef = this.$refs.xInputRef
        }

        if (inputRef) {
          // Element UI/Element Plus 的 el-input-number 内部结构
          const inputElement = inputRef.$el.querySelector('input')
          if (inputElement) {
            // 延迟一下确保焦点已经设置
            setTimeout(() => {
              inputElement.select()
            }, 50)
          }
        }
      },
      // 处理Y值手动清空
      handleYClear() {
        this.yValue = null
        this.xValue = null
        this.yValueFilled = false
      },

      // 处理Y值变化
      handleYChange(value) {
        this.yValueFilled = value !== null && value != undefined && value !== ''
        if (this.yValueFilled && (this.xValue === null || this.xValue === undefined || this.xValue === '')) {
          this.xValue = 0
        } else if (!this.yValueFilled) {
          this.xValue = undefined
        }
      },
      // 处理X值失焦
      handleXBlur() {
        if(!this.yValueFilled) {
          if (!(this.xValue === null || this.xValue === undefined || this.xValue === '')) {
            this.yValue = 0;
            this.yValueFilled=true;
            return;
          }
        }
        if (this.yValueFilled && (this.xValue === null ||this.xValue === undefined || this.xValue === '')) {
          this.xValue = 0
        }
      },

      // 处理X值手动清空
      handleXClear() {
        if (this.yValueFilled) {
          this.$nextTick(() => {
            this.xValue = 0
          })
        }
      },

      // 公共方法：获取当前值
      getValues() {
        return {
          Y: this.yValue,
          X: this.xValue
        }
      },

      /**
       * 获取格式化后的包尺寸数据
       * 返回格式: {"X":"-1.00","Y":"-3.25"}
       * 数字必须为2位小数
       * 如果球镜或柱镜没填，返回空对象 {}
       */
      getPackagesize() {
        // 检查球镜和柱镜是否都有值
        const isYValid = this.yValue !== null && this.yValue !== undefined && this.yValue !== '' && !isNaN(Number(this.yValue))
        const isXValid = this.xValue !== null && this.xValue !== undefined && this.xValue !== '' && !isNaN(Number(this.xValue))

        // 如果球镜或柱镜没填，返回空对象
        if (!isYValid || !isXValid) {
          return ""
        }

        // 格式化数字为2位小数
        const formatNumber = (num) => {
          const number = Number(num)
          return number.toFixed(2)
        }

        var pag= {
          X: formatNumber(this.xValue),
          Y: formatNumber(this.yValue)
        }
        return JSON.stringify(pag)
      },


      // 公共方法：重置
      reset() {
        this.yValue = null
        this.xValue = null
        this.yValueFilled = false
        this.emitValues()
      },

      // 公共方法：设置值
      setValues(values) {
        if (values) {
          this.yValue = values.Y !== undefined ? values.Y : null
          this.xValue = values.X !== undefined ? values.X : null
          this.yValueFilled = this.yValue !== null && this.yValue !== ''

          // 触发更新
          this.emitValues()
        }
      }
    },

    mounted() {
    }
  }
</script>

<style scoped>
  .lens-input-component {
    padding: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/LensInput.vue